import { render } from "./VueEditor.vue?vue&type=template&id=32e41a1a&scoped=true"
import script from "./VueEditor.vue?vue&type=script&lang=js"
export * from "./VueEditor.vue?vue&type=script&lang=js"

import "./VueEditor.vue?vue&type=style&index=0&id=32e41a1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e41a1a"]])

export default __exports__